@if(orderSummary.length) {
<div class="flex justify-content-end mt-4">
    <div class="w-4">
        <p-table [value]="orderSummary" showGridlines class="custom-bordered-table">
            <ng-template pTemplate="header">
                <tr>@if(isReturn) {
                    <th translate> order.lbl_return_summary </th>
                    } @else {
                    <th translate> order.lbl_order_summary </th>
                    }
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                <tr [ngClass]="{ 'last-row': rowIndex === orderSummary.length - 1 }">
                    <td>{{ product.name }}</td>
                    <td [ngClass]="{ 'last-row': rowIndex === 0 }">
                        @if (product.isPrice) {
                        <span>$</span>{{product.qty | number:'1.2-2'}}
                        } @else {
                        {{product.qty}}
                        }
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
}